import { Bell, X } from 'lucide-react'
import { useEffect, useState } from 'react'

export function PushNotifBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!('Notification' in window)) return
    if (Notification.permission !== 'default') return
    const t = setTimeout(() => setVisible(true), 9000)
    return () => clearTimeout(t)
  }, [])

  async function allow() {
    setVisible(false)
    const perm = await Notification.requestPermission()
    if (perm === 'granted') {
      new Notification('TurfChale 🟢', {
        body: "You're all set! We'll notify you about bookings and slot openings.",
      })
    }
  }

  if (!visible) return null

  return (
    <div
      className="fixed top-20 right-4 z-50 w-75 rounded-2xl p-4 transition-all duration-300"
      style={{ background: 'var(--bg3)', border: '1px solid var(--lime-line)' }}
    >
      <div className="flex items-start gap-2 mb-3">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
          style={{ background: 'var(--lime-dim)' }}
        >
          <Bell size={15} style={{ color: 'var(--lime)' }} />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold" style={{ color: 'var(--text)' }}>
            Stay in the game
          </p>
          <p className="text-xs leading-relaxed mt-0.5" style={{ color: 'var(--muted)' }}>
            Get notified when a slot opens at your favourite turf.
          </p>
        </div>
        <button onClick={() => setVisible(false)} style={{ color: 'var(--muted)' }}>
          <X size={15} />
        </button>
      </div>
      <div className="flex gap-2">
        <button
          className="flex-1 text-xs font-bold py-2 rounded-full"
          onClick={allow}
          style={{ background: 'var(--lime)', color: 'var(--bg)' }}
        >
          Allow notifications
        </button>
        <button
          className="text-xs px-3 py-2 rounded-full border"
          onClick={() => setVisible(false)}
          style={{ borderColor: 'var(--lime-line)', color: 'var(--muted)' }}
        >
          Not now
        </button>
      </div>
    </div>
  )
}
